import React from 'react';

import * as Styled from './toggle.style';

export type ToggleProps = Omit<React.ComponentProps<'input'>, 'value'> & {
  value: string | number;
  isSmall?: boolean;
};

export const Toggle: React.FC<ToggleProps> = ({ id, isSmall, ...rest }) => (
  <Styled.Container htmlFor={id}>
    <Styled.Input type="checkbox" {...rest} id={id} $isSmall={!!isSmall} />
    <Styled.ToggleLabel role="checkbox" htmlFor={id} $isSmall={!!isSmall} />
  </Styled.Container>
);
